export const actionTypes = {
    GET_GATEWAY_LIST_SETTINGS: 'powertrainTools/gatewayManagement/GET_GATEWAY_LIST_SETTINGS',
    GET_GATEWAY_LIST: 'powertrainTools/gatewayManagement/GET_GATEWAY_LIST',
    GET_GATEWAY_TYPE_SETTINGS: 'powertrainTools/gatewayManagement/GET_GATEWAY_TYPE_SETTINGS',
    GET_GATEWAY_TYPE: 'powertrainTools/gatewayManagement/GET_GATEWAY_TYPE',
    SELECT_ASSET: 'powertrainTools/gatewayManagement/SELECT_ASSET',
    OPEN_SERIAL_NUMBER_EDITOR_MODAL: 'powertrainTools/gatewayManagement/OPEN_SERIAL_NUMBER_EDITOR_MODAL',
    CLOSE_SERIAL_NUMBER_EDITOR_MODAL: 'powertrainTools/gatewayManagement/CLOSE_SERIAL_NUMBER_EDITOR_MODAL',
    ASSIGN_SERIAL_NUMBER_SETTINGS: 'powertrainTools/gatewayManagement/ASSIGN_SERIAL_NUMBER_SETTINGS',
    ASSIGN_SERIAL_NUMBER: 'powertrainTools/gatewayManagement/ASSIGN_SERIAL_NUMBER',
    GET_DRIVE_APPLICATIONS_SETTINGS: 'powertrainTools/gatewayManagement/GET_DRIVE_APPLICATIONS_SETTINGS',
    GET_DRIVE_APPLICATIONS: 'powertrainTools/gatewayManagement/GET_DRIVE_APPLICATIONS',
    GET_UPDATE_ASSET_DRIVE_APPLICATION_SETTINGS: 'powertrainTools/gatewayManagement/GET_UPDATE_ASSET_DRIVE_APPLICATION_SETTINGS',
    GET_UPDATE_ASSET_DRIVE_APPLICATION: 'powertrainTools/gatewayManagement/GET_UPDATE_ASSET_DRIVE_APPLICATION',
    SET_SELECTED_GATEWAY: 'powertrainTools/gatewayManagement/SET_SELECTED_GATEWAY',
    CLEAR_STORE: 'powertrainTools/gatewayManagement/CLEAR_STORE',
    CLEAR_DRIVE_APPLICATIONS: 'powertrainTools/gatewayManagement/CLEAR_DRIVE_APPLICATIONS'
};

export const assetOnlineStatus = {
    ONLINE: 'Online',
    OFFLINE: 'Offline'
};

export const summaryConnectionStatusValues = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    CONNECTED_WITH_WARNING: 'Connected with warning',
};

export const ASSET_DETAILS_LABEL = {
    ASSET_NAME: 'Asset Name',
    SERIAL_NUMBER: 'Serial Number',
    APPLICATION: 'Application'
};

export const GATEWAY_MAIN_TABS = {
    MY_GATEWAYS: 'my-gateways',
    OTHER_GATEWAYS: 'other-gateways'
};

export const GATEWAY_SUB_TABS = {
    EMPTY_GATEWAYS: 'empty-gateways',
    UNKNOWN_GATEWAYS: 'unknown-gateways'
};

export const GATEWAY_MAIN_TYPES = {
    MY_GATEWAYS: 'mygateways',
    OTHER_GATEWAYS: 'othergateways',
};

export const GATEWAY_SUB_TYPES = {
    EMPTY: 'empty',
    UNKNOWN: 'unknown',
    NONE: 'none'
};

export const ARROW_RIGHT = 'ArrowRight';

export const GATWAY_CONNECTIVITY_STATUS = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
    CONNECTED_WITH_WARNING: 'Connected with warning'
};

export const ASSET_NAME_MAX_LENGTH = 100;
